<div *ngIf="loggedIn">
    <app-footer></app-footer>
    <app-top-nav></app-top-nav>
    <app-global-modal [firstPara]="firstPara" [scdPara]="scdPara" [showModal]="showModal" [count]="count"
        (dialogAnswer)="showLogoutModal($event)">
    </app-global-modal>
</div>
<router-outlet></router-outlet>

<div class="pwa-install-banner" *ngIf="showInstallBanner">
    <img src="assets/icons/icon-72x72.png" alt="Zenplans" class="pwa-banner-icon" />
    <div class="pwa-banner-text">
        <strong>Add Zenplans to your home screen</strong>
        <span>Quick access, works offline</span>
    </div>
    <button class="pwa-btn-install" (click)="installApp()">Install</button>
    <button class="pwa-btn-dismiss" (click)="dismissInstallBanner()">&#x2715;</button>
</div>

<div class="pwa-ios-banner" *ngIf="showIosBanner">
    <button class="pwa-btn-dismiss" (click)="dismissIosBanner()">&#x2715;</button>
    <img src="assets/icons/icon-72x72.png" alt="Zenplans" class="pwa-banner-icon" />
    <div class="pwa-banner-text">
        <strong>Install Zenplans on your iPhone</strong>
        <span>
            Tap
            <svg class="ios-share-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                <path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"/>
                <path d="M24 7h2v21h-2z"/>
                <path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"/>
            </svg>
            then <strong>"Add to Home Screen"</strong>
        </span>
    </div>
</div>